import { render, staticRenderFns } from "./ItemSeparate.vue?vue&type=template&id=3de74658&scoped=true&"
import script from "./ItemSeparate.vue?vue&type=script&lang=js&"
export * from "./ItemSeparate.vue?vue&type=script&lang=js&"
import style0 from "./ItemSeparate.vue?vue&type=style&index=0&id=3de74658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de74658",
  null
  
)

export default component.exports